import React from "react";
import { Link } from "react-router-dom";
import "../CSS/Legal.css";
import LanguageSwitch from "../../components/LanguageSwitch";

const PrivacyPolicyAR = () => {
  return (
    <div className="legal-page rtl" dir="rtl" lang="ar">
      <div className="legal-header">
        <h1>سياسة الخصوصية</h1>
        <LanguageSwitch />
        <p className="legal-updated">آخر تحديث: كانون الاول 2025</p>

        <div className="legal-actions">
          <a className="legal-btn" href="/legal/privacy-policy.ar.pdf" download>
            تنزيل PDF (AR)
          </a>
          <Link className="legal-btn outline" to="/privacy-policy">
            English
          </Link>
        </div>
      </div>

      <div className="legal-card">
        <p>
          تحترم StayVacay (“نحن”) خصوصيتك وتلتزم بحماية بياناتك الشخصية وفقًا لقانون دولة الإمارات العربية المتحدة
          الاتحادي رقم 45 لسنة 2021 بشأن حماية البيانات الشخصية (PDPL).
        </p>

        <h2>1. المعلومات التي نجمعها</h2>
        <ul>
          <li>تفاصيل الاستفسار والحجز</li>
          <li>ملفات تعريف الارتباط (الكوكيز) وتقنيات مشابهة</li>
        </ul>
        <p>لا نقوم عن قصد بجمع بيانات من أشخاص دون سن 18 عامًا.</p>

        <h2>2. كيفية استخدام المعلومات</h2>
        <ul>
          <li>الرد على الاستفسارات وطلبات الحجز</li>
          <li>التواصل عبر البريد الإلكتروني أو واتساب</li>
          <li>تحسين الموقع والخدمات</li>
          <li>تعزيز الأمان ومنع الاحتيال</li>
          <li>الامتثال للالتزامات القانونية</li>
        </ul>

        <h2>3. مشاركة البيانات</h2>
        <p>لا نقوم ببيع بياناتك الشخصية.</p>
        <p>قد نشارك بياناتك فقط مع:</p>
        <ul>
          <li>مُلّاك/مديري العقارات (لأغراض الحجز)</li>
          <li>مزودي الخدمات (الاستضافة، التحليلات، أدوات التواصل)</li>
          <li>الجهات الرسمية عند الطلب وفقًا لقانون الإمارات</li>
        </ul>

        <h2>4. التخزين والأمان</h2>
        <p>
          نتخذ إجراءات تقنية وتنظيمية معقولة لحماية البيانات من الوصول غير المصرح به أو الفقدان أو إساءة الاستخدام.
          نحتفظ بالبيانات للمدة اللازمة فقط أو حسب ما يقتضيه القانون.
        </p>

        <h2>5. ملفات تعريف الارتباط</h2>
        <p>
          نستخدم الكوكيز لتحسين الأداء وفهم سلوك الاستخدام وتعزيز تجربة المستخدم. يمكنك التحكم بها من إعدادات المتصفح.
        </p>

        <h2>6. حقوقك</h2>
        <p>
          وفقًا لقوانين حماية البيانات في الإمارات، يمكنك طلب الوصول إلى بياناتك أو تصحيحها أو حذفها، أو سحب الموافقة
          حيث ينطبق ذلك.
        </p>

        <h2>7. التعديلات</h2>
        <p>قد نقوم بتحديث هذه السياسة من وقت لآخر. سيتم نشر أي تغييرات على هذه الصفحة.</p>

        <h2>8. التواصل</h2>
        <p>
          للاستفسارات أو الطلبات المتعلقة بالخصوصية:
          {" "}
          <a href="mailto:contact@stayvacay.ae">contact@stayvacay.ae</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyAR;
